import { createService } from '../../utils';

export const StandardService = createService({
  title: 'Стандарт',
  subTitle: 'До х2 звонков',
  description: ['Отличный старт', 'Заметнее в поиске', 'Выше публикаций'],
  dataName: 'StandardService',
  bgColor: 'white',
});
